module.exports = __webpack_public_path__ + "static/media/2023-VC-Feature-Banner-Tablet@1x.62e398e1.jpg";